// extracted by mini-css-extract-plugin
export default {"bug_report_wrapper":"Reports_bug_report_wrapper__NlGAp","bug_report_form":"Reports_bug_report_form__Zd5+1"};